export default __webpack_public_path__ + "static/media/recSummer.8d2a954a.png";